import ColumnSet from '@/components/grid/columns/column-set';
import taxCategories from '@/data/tax-categories';
import store from '@/store';
import emptyInnerHTML from '@/common/helpers/empty-inner-html';
import listSummary from '@/common/helpers/list-summary';
import auth from '@/common/auth/auth';

export default new ColumnSet({
    id: 'products-list',
    store,
    version: 6,
    defaultColumns: [
        {
            name: 'id',
            style: {truncate: true},
            sortable: true,
            type: 'link',
            to: ({fields}) => ({
                name: 'product-details',
                params: {id: fields.id},
            }),
            predicate: auth.$pages['product-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sticky: true,
        },
        {
            name: 'name',
            sortable: true,
        },
        {
            name: 'PricingPlans',
            value: (fields) => {
                if (fields.plans.length) {
                    const values = fields.plans.map(value => value.fields.name);
                    return listSummary(values, 4);
                }
                return emptyInnerHTML;
            },
        },
        {
            name: 'createdTime',
            header: 'Creation Time',
            type: 'datetime',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'description',
            sortable: true,
        },
        {
            name: 'taxCategoryId',
            sortable: true,
        },
        {
            name: 'taxCategoryDescription',
            value: (fields) => {
                const match = taxCategories
                    .find(taxCategory => taxCategory.taxCode === fields.taxCategoryId);
                if (match) {
                    return match.description;
                }
                return null;
            },
            sortable: true,
        },
        {
            name: 'requiresShipping',
            /* eslint-disable */
            value: fields => fields.requiresShipping ? 'Yes' : 'No',
            /* eslint-enable */
            sortable: true,
        },
        {
            name: 'accountingCode',
            sortable: true,
        },
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
    ],
});
